"use client";

import type { PitchMiddleware } from "@/app/(application)/(normal)/create/components/input/types";
import { keyStore } from "@/components/pitchCorrection/PitchCorrection";
import { calculatePitchesForPitchChange } from "@/components/pitchCorrection/pitchKnob/calculatePitchesForPitchChange";
import { KeyOption } from "@/types/defs/keyOption";

export const pitchShiftMiddleware =
  (pitchShiftLevelZ: number, keyZ: KeyOption): PitchMiddleware =>
  ({ circles }) =>
  (pitches) =>
    pitchShiftLevelZ === 0 ? pitches : (
      calculatePitchesForPitchChange(
        pitchShiftLevelZ,
        keyStore([])[keyZ],
        circles,
        0,
        pitches
      )
    );
